import { render, staticRenderFns } from "./ContactEditorDialog.vue?vue&type=template&id=35f17889&"
import script from "./ContactEditorDialog.vue?vue&type=script&lang=js&"
export * from "./ContactEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports